import { render, staticRenderFns } from "./LaboratoryCategoryFilter.vue?vue&type=template&id=0fe57ff4"
import script from "./LaboratoryCategoryFilter.vue?vue&type=script&lang=js"
export * from "./LaboratoryCategoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports